import { Eye } from "lucide-react";
import { Alert } from "@shared/components/ui/alert";

/** Bandeau « lecture seule » affiché quand l'équipe consulte l'espace d'un client. */
export function WorkspaceBanner({ children }: { children: React.ReactNode }) {
  return (
    <Alert className="mb-6.5 flex items-center gap-2.5 bg-muted text-foreground" role="status">
      <Eye aria-hidden="true" className="size-4 shrink-0" />
      <p className="m-0 text-[12.5px] font-semibold">{children}</p>
    </Alert>
  );
}
